export const validate = (
  length: number,
  message = `maximal ${length} zeichen erlaubt`
) => (value: string) => (value || "").length <= length || message;
